  <link rel="icon" type="image/x-icon" href="/media/favicon/favicon.ico" />
  <link rel="shortcut icon" type="image/x-icon" href="/media/favicon/favicon.ico" />

  <link rel="apple-touch-icon" href="/media/favicon/apple-touch-icon-57x57.png" />
  <link rel="apple-touch-icon" sizes="72x72" href="/media/favicon/apple-touch-icon-72x72.png" />
  <link rel="apple-touch-icon" sizes="114x114" href="/media/favicon/apple-touch-icon-114x114.png" />
  <link rel="apple-touch-icon" sizes="144x144" href="/media/favicon/apple-touch-icon-144x144.png" />


<link rel="manifest" href="/media/favicon/site.webmanifest">
<link rel="mask-icon" href="/media/favicon/safari-pinned-tab.svg" color="#ba2c2b">
<meta name="msapplication-TileColor" content="#da532c">
<meta name="theme-color" content="#ffffff">